// Downscale an uploaded file to a reasonable dataURL. We keep generous quality
// so prints stay sharp: 1200px leaves plenty of headroom for a 45mm pin at
// 300 DPI (~531px) even when the user zooms/crops inside the cell, and q0.92
// is near-lossless for photos & logos. Still far lighter than a raw camera file.
const MAX_DIM = 1200;
const JPEG_QUALITY = 0.92;

export function fileToDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function downscaleDataURL(dataURL) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;
      const scale = Math.min(1, MAX_DIM / Math.max(width, height));
      const w = Math.round(width * scale);
      const h = Math.round(height * scale);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      // white bg for JPEG (in case of transparency)
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL("image/jpeg", JPEG_QUALITY));
    };
    img.onerror = () => resolve(dataURL);
    img.src = dataURL;
  });
}

export async function processImageFile(file) {
  const raw = await fileToDataURL(file);
  return await downscaleDataURL(raw);
}
